import React from 'react'
import Footer from '../components/Shared/Footer'
import { Link } from 'react-router-dom';


const ReducarbBenefits = () => {
  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Reducarb Benefits</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active"><span className="fw-bold">Redu</span>carb benefits</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fresh-vegetable-section ">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 d-flex align-items-center mb-3">

              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/ReducarbBenifits/reducarbbenifits_1.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>


            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                      <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> Benefits
                      </h1>
                    </div>
                    <div className="font-xsm text-justify" style={{textAlign: 'justify'}}>
                      <p>
                        Reducarb is a low carbohydrate, high fiber and plant protein diet regimen. Evidence has proved that, carbohydrate reduction along with high fiber and proteins (especially from plant source) has helped in improving insulin sensitivity, weight reduction and blood sugar management.
                      </p>
                      <p>
                        Indian National survey has shown that, we are eating high carbohydrates (much above the recommended limits of 135g per day, Ref: RDAs ICMR NIN 2020). High carbohydrate intake leads to higher insulin state ultimately leading to insulin resistance (body stop responding to insulin).
                      </p>
                      <p>
                        Insulin resistance is one of the key culprits for overweight, abdominal obesity, pre diabetes, abnormal lipid profiles, high blood pressure and many other conditions like fatty liver (very high fat deposition in the liver) and Polycystic ovarian disease (in females).
                      {/* </p>
                      <p> */}
                        Dietary interventions focused on restriction of daily carbohydrates reduces insulin resistance and thus helps reversing all these abnormalities. <br></br>
                        Reducarb as partial meal replacement program helps in reducing daily carbohydrates….mindfully !!!

                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className='font-sm fw-semibold text-center'>
            Daily carbohydrate restriction replacing it with fibers and proteins helps in :
          </div>
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 padding-blue-card-section">
              <div className="card-container-blue-card">

                <div className="card-side-blue-card front-blue-card">
                  <div className="image-container-blue-card">
                    <img
                      src="../assets/images/Unhealthy/one.jpg"
                      alt="Unhealthy six"
                      className="custom-image-blue-card"
                    />
                    <h2 className="heading-blue-card">Pre- Diabetes</h2>
                  </div>
                </div>

                <div className="card-side-blue-card back-blue-card ">
                  <div>
                    <p className='text-white'>
                    Pre-diabetes means your blood glucose levels are higher than normal but not high enough to be diagnosed as diabetes. Pre-diabetes, in other words simply means being on the edge of getting diabetes, a stage before you may become a diabetic.
                    Reduction of daily carbohydrate intake improves body response to insulin. Insulin sensitive body handles blood sugar effectively.
                    </p>
                    <div className='font-md fw-semibold '>
                    <Link to="/pre-diabetes">Know More</Link>

                    </div>

                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-6 padding-blue-card-section">
              <div className="card-container-blue-card">

                <div className="card-side-blue-card front-blue-card">
                  <div className="image-container-blue-card">
                    <img
                      src="../assets/images/Unhealthy/abdominal.jpg"
                      alt="Unhealthy six"
                      className="custom-image-blue-card"
                    />
                    <h2 className="heading-blue-card">Abdominal Obesity</h2>
                  </div>
                </div>

                <div className="card-side-blue-card back-blue-card ">
                  <div>
                    <p className='text-white'>
                    Also known as central obesity, is a condition where there is an excessive amount of fat around the belly.
                    Reduction of daily carbohydrates reduces fat deposition at wrong places. It prevents fat deposition around your belly (abdominal obesity) and important organs. This improves their function. Please note, insulin resistance along with  abdominal obesity is one of key risk factor for obesity, heart diseases and diabetes.
                    </p>
                    <div className='font-md fw-semibold '>
                    <Link to="/abdominal-obesity">Know More</Link>

                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 padding-blue-card-section">
              <div className="card-container-blue-card">

                <div className="card-side-blue-card front-blue-card">
                  <div className="image-container-blue-card">
                    <img
                      src="../assets/images/Unhealthy/unhealthy.jpg"
                      alt="Unhealthy six"
                      className="custom-image-blue-card"
                    />
                    <h2 className="heading-blue-card">Unhealthy Dietary Habits</h2>
                  </div>
                </div>

                <div className="card-side-blue-card back-blue-card ">
                  <div>
                    <p className='text-white'>
                    Reduction of daily carbohydrate intake and replacing it with high fibers and proteins (especially from plant source) improves quality of your food intake. It helps  maintain appropriate weight and keep your body sensitive to insulin and other body hormones.
                    </p>
                    <div className='font-md fw-semibold '>
                    <Link to="/unhealthy">Know More</Link>
                    </div>

                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-6 padding-blue-card-section">
              <div className="card-container-blue-card">

                <div className="card-side-blue-card front-blue-card">
                  <div className="image-container-blue-card">
                    <img
                      src="../assets/images/Unhealthy/heart_disease.jpg"
                      alt="Unhealthy six"
                      className="custom-image-blue-card"
                    />
                    <h2 className="heading-blue-card">Risk of Heart Diseases</h2>
                  </div>
                </div>

                <div className="card-side-blue-card back-blue-card ">
                  <div>
                    <p className='text-white'>
                    Reduction of daily carbohydrates improves or reverses metabolic syndrome.  It consists of abdominal obesity (larger waist line beyond cut offs), high sugar, abnormal lipids (high BAD cholesterol and low GOOD cholesterol) and high blood pressure. All these are risk factors for future heart diseases
                    </p>
                    <div className='font-md fw-semibold '>
                    <Link to="/risk-heart-disease">Know More</Link>

                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>
      </section>

      <div >
        <Footer />
      </div>
    </div>
  )
}

export default ReducarbBenefits
